// removed by extract-text-webpack-plugin
module.exports = {"container":"PropertiesPagination-hashed__container__zLoUp"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/propertiespagination/PropertiesPagination-hashed.scss
// module id = 708
// module chunks = 0